import React, { useState } from 'react';
import StateDropDown from './StateDropDown';
import FancyInput from '../FancyInput';

const validateLicenseNumber = value =>
  !value || /^[A-Z0-9]{1,19}$/i.test(value);

export default function DriversLicenseInput({ value, onChange }) {
  const { licenseNumber = '', licenseState = '' } = value;
  const [touched, setTouched] = useState(false);

  const handleFocus = () => {
    setTouched(true);
  };

  const handleLicenseChange = (e) => {
    const newValue = e.target.value;
    if (validateLicenseNumber(newValue)) {
      onChange({ licenseNumber: newValue, licenseState });
    }
  };

  const showError = touched && !licenseNumber;

  return (
    <div className="drivers-license">
      <FancyInput
        type="text"
        value={licenseNumber}
        className={`edit-license ${showError ? 'invalid' : ''}`}
        placeholder="License Number"
        maxLength="19"
        onFocus={handleFocus}
        onChange={handleLicenseChange}
      />
      {showError ? (
        <span className="license-invalid">
          Please enter a valid license number.
        </span>
      ) : null}
      <label htmlFor="stateDropDown" className="attach">
        State
      </label>
      <StateDropDown
        value={licenseState}
        disabled={false}
        onChange={e =>
          onChange({ licenseNumber, licenseState: e.target.value })
        }
      />
    </div>
  );
}
